export default "__VITE_ASSET__DU_Gg9u7__"